import { useEffect, useState } from "react";
import { accordionHandler, isMobileScreen } from "@/utils/functions";
import H3 from "@/atoms/text/H3";
import { ChevronArrowIcon } from "@/atoms/Icons";

const Sidebar = ({ data, onCategoryFilter, isResetting }) => {
  const [isMobile, setIsMobile] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [dropdownText, setDropdownText] = useState("All Integrations");

  useEffect(() => {
    setIsMobile(isMobileScreen);
  }, []);

  useEffect(() => {
    if (isResetting) {
      setActiveIndex(0);
      setDropdownText("All Integrations");
    }
  }, [isResetting]);

  const sideBarDesktopHandler = (e, idx) => {
    setActiveIndex(idx);
    filterCards(e.target);
    e.target.closest("section").scrollIntoView({ behavior: "smooth" });
  };

  const sideBarMobileHandler = (e) => {
    const listItems = e.target.closest(".dropdown-btn");
    if (!listItems) {
      const targetElement = e.target.closest(".list--item");
      if (targetElement) {
        const categoryText = targetElement.innerText;
        const categories = targetElement.closest(".categories");
        const menus = categories ? [...categories.children] : [];
        menus.forEach((menu) => menu.classList.remove("active"));
        targetElement.classList.add("active");
        setDropdownText(categoryText);
        e.target.closest(".accordion-list").classList.remove("is-open");
      }
    }
  };

  const filterCards = (element) => {
    const listItem = element.closest(".list--item");
    const categoryId = listItem.dataset.categoryId;
    onCategoryFilter(categoryId);
  };

  return (
    <>
      {!isMobile ? (
        <aside className="sidebar w-100 mr-6">
          <H3 className="mb-5-d bold" desktopSize="sm">
            Categories<span className="dot">.</span>
          </H3>
          <ul className="list--items">
            {data.map((item, idx) => (
              <li
                key={idx}
                className={`list--item ${idx === activeIndex ? "active" : ""}`}
                data-category-id={item.categoryId}
                onClick={(e) => sideBarDesktopHandler(e, idx)}
              >
                <button className="text text--lg-d">{item.name}</button>
              </li>
            ))}
          </ul>
        </aside>
      ) : (
        <div
          className="dropdown-wrapper accordion-list mb-7 m-center"
          onClick={sideBarMobileHandler}
          id="dropdown-wrapper"
        >
          <button
            className="accordion dropdown-btn fx fx--sb w-100"
            onClick={accordionHandler}
          >
            <label className="dropdown-label">Filter by category</label>
            <span className="text text--md">{dropdownText}</span>
            <ChevronArrowIcon className="accordion-arrow" color="#707477" />
          </button>
          <ul className="categories">
            {data.map((item, idx) => (
              <li
                key={idx}
                className={`list--item mb-1 ${
                  idx === activeIndex ? "active" : ""
                }`}
                data-category-id={item.categoryId}
                onClick={(e) => filterCards(e.target)}
              >
                <button className="text text--lg-d">{item.name}</button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default Sidebar;
